// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_bar__eLbak {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline: 30px;
  margin-block: 15px;
  gap: 10px;
}

.styles_btn__bar__eYcEH {
  all: unset;
  cursor: pointer;
  background-color: #1976d2a7;
  color: #e8e8e8;
  width: 2.1rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: all 0.5s ease-in-out;
  box-shadow: 2px 2px 8px #00000091;

}

.styles_btn__bar__eYcEH:hover {
    background-color: #1976d2df;
    transform: scale(1.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/ToolBar/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,iCAAiC;;AAEnC;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB","sourcesContent":[".bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-inline: 30px;\n  margin-block: 15px;\n  gap: 10px;\n}\n\n.btn__bar {\n  all: unset;\n  cursor: pointer;\n  background-color: #1976d2a7;\n  color: #e8e8e8;\n  width: 2.1rem;\n  height: 2rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  transition: all 0.5s ease-in-out;\n  box-shadow: 2px 2px 8px #00000091;\n\n}\n\n.btn__bar:hover {\n    background-color: #1976d2df;\n    transform: scale(1.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `styles_bar__eLbak`,
	"btn__bar": `styles_btn__bar__eYcEH`
};
export default ___CSS_LOADER_EXPORT___;
